<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '远程更新信息'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    top="5%"
    width="50%"
    :close-on-click-modal="false"
  >
    <div class="border-style">基本信息</div>
    <el-form :model="item" ref="itemform" label-width="150px" :rules="rules">
      <el-form-item label="产品型号名称" prop="DciProductModelName">
        <el-select
          v-model="item.DciProductModelName"
          :clearable="false"
          placeholder="选择产品型号"
          style="width: 100%"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele"
            :label="ele"
            :value="ele"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="更新说明" prop="UpdateDesc">
        <el-input
          v-model.trim="item.UpdateDesc"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入更新说明"
        >
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="校验条件" prop="CheckCondition">
        <el-input
          v-model.trim="item.CheckCondition"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入校验条件"
        >
        </el-input>
      </el-form-item> -->
      <!-- <el-form-item label="下载地址" prop="DownloadUrl">
        <el-input
          v-model.trim="item.DownloadUrl"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入下载地址"
        >
        </el-input>
      </el-form-item> -->
      <el-form-item label="校验条件脚本上传" prop="file">
        <el-upload
          ref="upload"
          :multiple="false"
          :limit="1"
          :action="uploadUrl"
          :headers="uploadHeader"
          :file-list="fileList"
          :auto-upload="false"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-preview="handlePreview"
        >
          <el-button size="mini" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="更新包下载地址" prop="DownloadUrl">
        <el-input v-model="item.DownloadUrl" placeholder="请输入下载地址">
          <i
            slot="append"
            class="fa-solid fa-download"
            style="
              font-size: 18px;
              position: relative;
              top: 1px;
              padding-left: 0px;
            "
            @click="download(item.DownloadUrl)"
          ></i>
        </el-input>
      </el-form-item>
    </el-form>

    <div class="border-style">相关产品</div>
    <div class="toolbar">
      <el-button type="primary" size="mini" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 选择产品
      </el-button>
    </div>

    <el-table :data="productList">
      <el-table-column
        prop="DciProductModel.NameNumber"
        label="产品型号名称"
      ></el-table-column>
      <el-table-column prop="SN" label="产品SN"
        ><template slot-scope="scope">
          <el-tag v-if="scope.row.SN">
            {{ scope.row.SN }}
          </el-tag>
          <el-tag type="success" v-if="scope.row.Remark">
            {{ scope.row.Remark }}
          </el-tag>
        </template></el-table-column
      >
      <el-table-column
        prop="DciStation.Name"
        label="点位名称"
      ></el-table-column>
      <el-table-column width="80" label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>

    <choose-product
      v-model="item"
      :visible.sync="productvisible"
      @form:saved="updateProductList"
    />
  </el-dialog>
</template>

<script>
import ChooseProduct from "./chooseProduct.vue";
export default {
  components: {
    ChooseProduct,
  },
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        DciProductModelName: [
          { required: true, message: "产品型号不能为空", trigger: "blur" },
        ],
        UpdateDesc: [
          { required: true, message: "更新说明不能为空", trigger: "blur" },
        ],
        CheckCondition: [
          { required: true, message: "校验条件不能为空", trigger: "blur" },
        ],
        DownloadUrl: [
          { required: true, message: "下载地址不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      modelList: [], //产品型号
      requestRegObj: {
        reg: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, // eslint-disable-line
        msg: "URL格式不正确",
      },
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      uploadUrl: "",
      fileList: [],
      removeList: [],
      productList: [],
      productvisible: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  mounted() {
    // this.$refs.itemform.resetFields();
    // this.$refs.upload.clearFiles();
    this.fileList = [];
    this.removeList = [];
    this.item = {};
    this.productList = [];
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.productList = this.item.DciProducts;
      this.uploadUrl = `api/dci/remoteupdate/upload`;
      if (this.item.Attachments) {
        this.value.Attachments.forEach((ele) => {
          const file = {};
          file.name = ele.Name;
          file.url = ele.Url;
          this.fileList.push(file);
        });
      } else {
        this.item.Attachments = [];
      }
      this.getModelList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.removeList = [];
      this.productList = [];
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.requestRegObj.reg.test(this.item.DownloadUrl)) {
          this.$message({
            type: "warning",
            message: `URL格式不正确`,
          });
          return;
        }
        this.submitting = true;

        var ids = [];
        for (let i in this.productList) {
          ids.push(this.productList[i].ID);
        }
        this.item.DciProductIDs = ids;

        this.attnum = 0; //有没有新上传附件
        this.$refs.upload.uploadFiles.forEach((item) => {
          if (item.status === "ready") {
            this.attnum += 1;
          }
        });
        if (this.attnum > 0) {
          this.atttimes = 0;
          this.$refs.upload.uploadFiles.map((item) => item.status === "ready");
          this.$refs.upload.submit();
        } else {
          this.lastSubmit();
        }

        // this.$emit("input", this.item);
        // const itemData = { ...this.item };
        // // 保存的操作
        // this.$axios
        //   .request({
        //     url: this.item.ID
        //       ? `dci/remoteupdate/${itemData.ID}`
        //       : "dci/remoteupdate",
        //     method: itemData.ID ? "put" : "post",
        //     data: itemData,
        //   })
        //   .then(() => {
        //     this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
        //     this.submitting = false;
        //     this.$emit(itemData.ID ? "form:updated" : "form:created", true);
        //     this.$emit("form:saved", true);
        //     this.$emit("update:visible", false);
        //   })
        //   .catch(({ response }) => {
        //     this.$sys.alarmResponse(response);
        //     this.submitting = false;
        //     this.$emit(itemData.ID ? "form:updated" : "form:created", false);
        //     this.$emit("form:saved", false);
        //   });
      });
    },
    onCreateItem() {
      if (this.item.DciProductModelName === undefined) {
        this.$message({
          type: "warning",
          message: `请选择产品类型名称后再操作`,
        });
        return;
      }
      this.productvisible = true;
    },
    updateProductList(list) {
      var arr = [];
      var ids = [];
      //去重
      if (this.productList != null) {
        arr = this.productList;
      }
      for (let i in arr) {
        ids.push(arr[i].ID);
      }
      for (let i in list) {
        if (ids.indexOf(list[i].ID) == -1) {
          ids.push(list[i].ID);
          arr.push(list[i]);
        }
      }
      this.productList = arr;
    },
    onDeleteItem(row) {
      for (let i in this.productList) {
        if (this.productList[i].ID == row.ID) {
          this.productList.splice(i, 1);
          break;
        }
      }
    },
    download(url) {
      if (!this.requestRegObj.reg.test(url)) {
        this.$message({
          type: "warning",
          message: `URL格式不正确`,
        });
        return;
      }
      this.onDownload(url);
    },
    //下载
    async onDownload(downurl) {
      const { data } = await this.$axios({
        url: downurl,
        responseType: "blob",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      });
      const blob = new Blob([data], {
        type: "application/*;chartset=UTF-8",
      });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      // let filename = row.NewVersion;
      // if (row.NewUrl.indexOf("/") !== -1) {
      //   const arr = row.NewUrl.split("/");
      //   filename = arr[arr.length - 1];
      // }

      a.href = url;
      // a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    handleSuccess(response) {
      this.item.Attachments.push(response);
      this.atttimes += 1; //第几次调用改方法（每个文件都会调用一次，最后一次再触发保存）

      if (this.atttimes === this.attnum) {
        this.lastSubmit();
      }
    },
    handleRemove(file) {
      if (file.status === "success") {
        this.removeList.push(file.url);
      }
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
    lastSubmit() {
      if (this.removeList.length !== 0) {
        this.removeList.forEach((ele) => {
          this.item.Attachments.splice(
            this.item.Attachments.findIndex((item) => item.Url === ele),
            1
          );
        });
        this.$axios.delete("dci/remoteupdate/dispose", {
          data: { file: this.removeList },
        });
      }
      this.$axios
        .request({
          url: this.item.ID
            ? `dci/remoteupdate/${this.item.ID}`
            : "dci/remoteupdate",
          method: this.item.ID ? "put" : "post",
          data: this.item,
        })
        .then(() => {
          this.$message.success(this.item.ID ? "编辑成功" : "新增成功");
          this.$emit("form:saved", true);
          this.$emit("form:done", true);
          this.onClose();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.dialogDiv {
  height: 450px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>

